import { filtersHelper } from '@/utils';
import { candidateEducationModel } from '@/models/api/candidateEducation.model';
import { candidateExperienceModel } from '@/models/api/candidateExperience.model';
import { candidateFamilyModel } from '@/models/api/candidateFamily.model';
import { candidateLanguageModel } from '@/models/api/candidateLanguage.model';
import { candidateMedicalModel } from '@/models/api/candidateMedical.model';
import { candidateJobModel } from '@/models/api/candidateJob.model';
import { candidateStatusModel } from '@/models/api/candidateStatus.model';
import { candidateStatusLogModel } from '@/models/api/candidateStatusLog.model';
import { userModel } from '@/models/api/user.model';

export const candidateModel = (data) => ({
    uuid: data.uuid,
    firstName: data.first_name,
    lastName: data.last_name,
    englishName: data.english_name,
    email: data.email,
    companyEmail: data.company_email,
    phoneIso: data.phone_iso,
    phoneCode: data.phone_code,
    phoneNumber: data.phone_number,
    homePhoneIso: data.home_phone_iso,
    homePhoneCode: data.home_phone_code,
    homePhoneNumber: data.home_phone_number,
    birthDate: data.birth_date,
    birthPlace: data.birth_place,
    race: data.race,
    ethnicity: data.ethnicity,
    religion: data.religion,
    nationality: data.nationality,
    malaysiaId: data.malaysia_id,
    passportNumber: data.passport_number,
    passportExpiredDate: data.passport_expired_date,
    imageUrl: data.image_url,
    resumeUrl: data.resume_url,
    expectedSalary: data.expected_salary,
    address1: data.address_1,
    address2: data.address_2,
    address3: data.address_3,
    city: data.city,
    state: data.state,
    postcode: data.postcode,
    country: data.country,
    gender: data.gender != null ? Number(data.gender) : null,
    maritalStatus: data.marital_status,
    callDuringWork: data.call_during_work,
    willingOt: data.willing_ot,
    willingToRelocate: data.willing_to_relocate,
    signatureImage: data.signature_image,
    signedAt: filtersHelper.getDateFormat(data.signed_at),
    isApplicationCompleted: data.is_application_completed,
    isDuplicated: data.is_duplicated,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    candidateEducations: (data.candidate_educations ?? []).map(item => candidateEducationModel(item)),
    candidateExperiences: (data.candidate_experiences ?? []).map(item => candidateExperienceModel(item)),
    candidateFamilies: (data.candidate_families ?? []).map(item => candidateFamilyModel(item)),
    candidateLanguages: (data.candidate_languages ?? []).map(item => candidateLanguageModel(item)),
    candidateMedical: data.candidate_medical ? candidateMedicalModel(data.candidate_medical) : null,
    candidateJob: data.candidate_job ? candidateJobModel(data.candidate_job) : null,
    candidateStatus: data.candidate_status ? candidateStatusModel(data.candidate_status) : null,
    candidateStatusLogs: (data.candidate_status_logs ?? []).map(item => candidateStatusLogModel(item)),
    user: data.user ? userModel(data.user) : null,
});
